import * as React from 'react';
import { IRoute } from 'lib/componentRouter';
import { Location, LocationParams } from 'lib/componentLocation';

import { AppWrapper } from 'portcall/appwrapper/model';
import { AppWrapperView } from 'portcall/appwrapper/view';

import { CoordinationConfigurator, CoordinationConfiguratorParams } from './model';
import { CoordinationConfiguratorView } from './view';

export function CoordinationConfiguratorRoute(
    model : (params : CoordinationConfiguratorParams) => CoordinationConfigurator,
    appWrapper: AppWrapper,
    request : Location
) : IRoute {
    const m = model(inboundParams(request));
    return {
        view:
            <AppWrapperView model={appWrapper}>
                <CoordinationConfiguratorView model={m} />
            </AppWrapperView>,
        reflectState: () => new Location(request.name, outboundParams(m))
    }
}

function inboundParams(request : Location) : CoordinationConfiguratorParams {
    const id = request.params['id'];
    return {
        id: id ? +id : undefined
    };
}

function outboundParams( m : CoordinationConfigurator) : LocationParams {
    const p = {} as LocationParams;

    if (m.Model.Id()) p['id'] = '' + m.Model.Id();

    return p;
}



// WEBPACK FOOTER //
// ./apps/portcall/coordinationconfigurator/route.tsx